import React from 'react';

export const CheckMark = ({ stroke }: { stroke?: string }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5405 0.780308L3.86992 10.2197L0.5 7.42865" stroke={stroke || "#2AC824"} strokeLinecap="round"/>
  </svg>
);
